
import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import moment from 'moment';
import * as firebase from 'firebase';
import '../../view/css/NavBar.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";

export const CreateEvent = () => {

    var firestore = firebase.firestore();
    var events = firestore.collection("Event");
    var user = firebase.auth().currentUser;
    var today = moment().format().slice(0, 16);

    const [open, setOpen] = React.useState(false);
    const [event_title, setTitle] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [nameError, setNameError] = React.useState(false);
    const [timeError, setTimeError] = React.useState(false);
    const [descError, setDescError] = React.useState(false);
    const [locError, setLocError] = React.useState(false);
    const [location, setLocation] = React.useState("");
    const [event_start, setStart] = React.useState("");
    const [event_end, setEnd] = React.useState("");
    const [tagsGotten, setTagsGotten] = React.useState(false);
    const [allTags, setAllTags] = React.useState([]);
    const [showEventSubmit, setEventSubmit] = React.useState(false);
    const [photos_event,setEventPhoto] = React.useState("");
    const [event_picy, setPicture] = React.useState("");
    const storage = firebase.storage();

    const [anchorEl, setanchorel] = React.useState(null);

    const [tags, setTags] = React.useState([]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        cancel_photo_event();
        setOpen(false);
        setTitle("");
        setDescription("");
        setLocation("");
        setStart("");
        setEnd("");
        setTags([]);
        setNameError(false);
        setTimeError(false);
        setDescError(false);
        setLocError(false);
    };
    const handleSubmit = async (image) => {

   
     
      
        var url = "";
     
        console.log('start of upload');
        if (image === '') {
            console.log('not an image');
        }
        if(image.name !=undefined){
        const check_dup = storage.ref('/images/' + image.name);
        try{
            var this_link = await check_dup.getDownloadURL();
            console.log("storage exists");
           
            setPicture(this_link);
        }catch{
            await check_dup.put(image);
            const this_image = await check_dup.getDownloadURL();
            setPicture(this_image);
  
        }
    }

    }
    const cancel_photo_event = async () => {
      
        setEventSubmit(false);
    }
    const dropClick = (e) => {
        setanchorel(e.currentTarget);
    }

    const dropClose = () => {
        setanchorel(null);
    }

    const getTags = () => {
        // This retrieves the fulle list of tags from the database
        const db = firestore.collection("Tag");
        var tags = [];
        db.get().then((data) => {
            data.forEach((doc) => {
                //add each doc.id into tags
                var tagName = doc.data().name; //let tags = tags.push(doc.id)
                if (tagName !== undefined) {
                    tags.push(tagName);
                }
            });
        });
        setTagsGotten(true);
        setAllTags(tags);
        console.log("All the tags: " + allTags);
    }

    const addEvent = async (e) => {
        e.preventDefault();

        if (event_title == "") {
            setNameError(true);
        } else {
            setNameError(false);
        }

        if ((event_end == "" || event_start == "")) {
            setTimeError(true);
        }

        if (description == ""){
            setDescError(true);
        }

        if (location == ""){
            setLocError(true);
        }

        let doccer = await firestore.collection("Users").doc(user.email).get();

        if (description !== "" && location !== "" && !timeError && !(event_end == "" || event_start == "") && event_title !== undefined && event_title !== null && event_title !== "") {
            events.doc(event_title).set({
                Affiliate: user.email,
                username: doccer.data().username,
                date_created: new Date(),
                event_start: new Date(event_start),
                event_end: new Date(event_end),
                description: description,
                event_title: event_title,
                location: location,
                picture: event_picy,  
                likes:0,                     //onSubmit - need to add
                tags: tags
            })

            const db = firestore.collection("Users").doc(user.email);
            db.get().then(function (doc) {
                if (doc.exists) {
                    const old_events = doc.data().events;
                    firestore.collection("Users").doc(user.email).update({
                        events: [...old_events, events.doc(event_title)]
                    })
                } else {
                    console.log('user not logged in');
                }

            }).catch(function (error) {
                console.log("Error getting document:", error);
            });

            //pushes notification of event created
            const aff = firestore.collection("Users").doc(user.email);
            aff.get().then(function (doc) {
                if (doc.exists) {
                    console.log(doc.data().students);
                    console.log("Mapping through students now.")
                    doc.data().students.map((student) =>{
                        const db = firestore.collection("Users").doc(student);
                        console.log("Notification update for " + student);
                        db.update({
                            notification: firebase.firestore.FieldValue.arrayUnion(events.doc(event_title))
                        });
                    })
                } else {
                    console.log('user not logged in');
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });

            handleClose();
        }
    }

    const inputTitle = (e) => {
        setTitle(e.target.value);
    }

    const inputDescription = (e) => {
        setDescription(e.target.value);
    }

    const addTag = (e) => {
        console.log("IN ADDTAG NOW");
        if (tags !== undefined) {
            if (!tags.includes(e.target.innerText)) {
                setTags([...tags, e.target.innerText]);
                console.log("TAGS TYPE " + tags);
            } else {
                setTags(tags.filter(tag => tag !== e.target.innerText))
            }
        }
    }
    const handleEventImageAsFile = (e) => {
        const image = e.target.files[0];
        console.log("image is " + image);
        
        handleSubmit(image);
        setEventSubmit(true);
     
    }
    const inputStart = (e) => {
        setStart(e.target.value);

        if (event_end < e.target.value) {
            setTimeError(true);
        } else {
            setTimeError(false);
        }
    }

    const inputEnd = (e) => {
        setEnd(e.target.value);

        if (event_start > e.target.value) {
            setTimeError(true);
        } else {
            setTimeError(false);
        }
    }

    const inputLocation = (e) => {
        setLocation(e.target.value);
    }

    return (
        <div className="CreateEvent">
            {!tagsGotten && getTags()}
            <img className="navIcons" onClick={handleClickOpen} src={process.env.PUBLIC_URL + '/digitalassets/addevent.png'} />
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Create Event</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {nameError && <i>Event name is required.</i>}
                        {timeError && <i>Please choose a valid start and end time.</i>}
                        {descError && <i>Please input a description.</i>}
                        {locError && <i>Please input a location.</i>}
                    </DialogContentText>
                    <form>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="event_title"
                            label="Event Name (required)"
                            type="event_title"
                            required="true"
                            fullWidth
                            onChange={inputTitle}
                            value={event_title}
                        />

                        <TextField
                            autoFocus
                            margin="dense"
                            id="description"
                            label="Event Description"
                            type="description"
                            fullWidth
                            required="true"
                            onChange={inputDescription}
                            value={description}
                        />

                        <TextField
                            id="event_start"
                            label="Event Start"
                            type="datetime-local"
                            defaultValue={today}
                            required="true"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{ min: today, max: event_end }}
                            onChange={inputStart}
                            value={event_start}
                        />

                        <TextField
                            id="event_end"
                            label="Event End"
                            type="datetime-local"
                            required="true"
                            defaultValue={today}
                            inputProps={{ min: event_start }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={inputEnd}
                            value={event_end}
                        />

                        <TextField
                            autoFocus
                            margin="dense"
                            id="location"
                            label="Event Location"
                            type="location"
                            required="true"
                            fullWidth
                            onChange={inputLocation}
                            value={location}
                        />
                          <div className ="oogabooga">
                    <img src={event_picy} className="StudentPicture" />

                    {!showEventSubmit && <label className="uploadevent" > Upload Picture<input className="FileChooser" type='file'  onChange={handleEventImageAsFile} accept='image/*' /></label>}
                    </div>
                        <Button className="UploadNewProfilePhotoButton" aria-controls="simple-menu" aria-haspopup="true" onClick={dropClick}>Choose Tags</Button>

                        <Menu
                            id="simple-menu"
                            setanchorel={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={dropClose}
                        >
                            {allTags.map((tag) => (
                                <MenuItem onClick={addTag} value={tag}>{tag}</MenuItem>
                            ))}
                        </Menu>


                        <h4>Tags chosen</h4>

                        {tags.map((tag) => (
                            <p>{tag}</p>
                        ))}

                    </form>
                </DialogContent>

                <DialogActions>
                    <Button onClick={addEvent} color="primary">
                        Add Event
                </Button>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}